module.exports = __webpack_public_path__ + "static/media/takeOutMenu.ce17e7ae.pdf";